import React from 'react'

const MatchDetailItem = ({
  type = '',
  persons = []
}) => {
  let officials = persons.map((p)=>{
    return p.name
  })

  officials = officials.join(', ')

  return (
    <li className="cricinfo__content__detail__list__item">
      <span className="cricinfo__type__weight--bold">{type} :</span>{officials}
    </li>
  )
}

const MatchOfficials = ({
  officials = {}
}) => {
  const umpire = officials.umpire && officials.umpire || []
  const tvUmpire = officials['tv umpire'] && officials['tv umpire'] || []
  const reserveUmpire = officials['reserve umpire'] && officials['reserve umpire'] || []
  const referee = officials.referee && officials.referee || []
  const props = [
    umpire.length,
    tvUmpire.length,
    reserveUmpire.length,
    referee.length
  ]
  let show = false

  // loops through all props and sets show=true
  // if any one of them is available
  for (var i = 0; i < props.length; i++) {
    if(props[i]) {
      show = true
    }
  }

  const content = (
    <div className="cricinfo__content__item">
      <h2 className="cricinfo__sub-title">Match Officials</h2>
      <div className="cricinfo__content__detail">
        <ul className="cricinfo__content__detail__list">
          {
            umpire.length &&
            <MatchDetailItem type="Umpires" persons={officials.umpire} /> || null
          }
          {
            tvUmpire.length &&
            <MatchDetailItem type="TV Umpires" persons={officials['tv umpire']} /> || null
          }
          {
            reserveUmpire.length &&
            <MatchDetailItem type="Reserve Umpire" persons={officials['reserve umpire']} /> || null
          }
          {
            referee.length &&
            <MatchDetailItem type="Match Referee" persons={officials.referee} /> || null
          }
        </ul>
      </div>
    </div>
  )

  return show ? content : <div className="cricinfo__content__item"/>
}

export default MatchOfficials



// WEBPACK FOOTER //
// ../app/components/gamepackage/cricket/lite/MatchOfficials.jsx